<template>
  <div class="container app-container">
    <el-form :inline="true" ref="search" :model="search" class="demo-form-inline">
      <el-form-item prop="user_name_or_tel">
        <el-input v-model="search.user_name_or_tel" placeholder="患者姓名/手机号"></el-input>
      </el-form-item>
      <el-form-item prop="nurse_name_or_tel">
        <el-input v-model="search.nurse_name_or_tel" placeholder="护工姓名/手机号"></el-input>
      </el-form-item>
      <el-form-item prop="order_status">
        <el-select v-model="search.order_status" placeholder="订单状态">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="option in OrderStatus" :key="option.val" :label="option.label"
                     :value="option.val"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="hospitals.length > 1" prop="order_status">
        <el-select v-model="search.hospital_name" placeholder="医院">
          <el-option
            v-for="option in hospitals"
            :key="option.name"
            :label="option.name"
            :value="option.name"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="rangeDate">
        <el-date-picker
          v-model="search.rangeDate"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchData">查询</el-button>
        <el-button @click="resetForm('search')">重置</el-button>
        <el-button v-if="isAdmin" @click="handleInsertOrder">创建订单</el-button>
      </el-form-item>
    </el-form>
    <div class="total">
      <span>订单总数： {{ total }} 条</span>
      <el-divider direction="vertical"></el-divider>
      <span>订单总金额：¥ {{ pay_total }}</span>
      <el-divider direction="vertical"></el-divider>
      <span>实际收入：¥ {{ actual_amount }}</span>
      <el-divider direction="vertical"></el-divider>
      <span>退款金额：¥ {{ refund }}</span>
    </div>
    <insert-order ref="InsertOrder" @success="getList"/>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      max-height="600"
      stripe
    >
      <el-table-column prop="order_no" label="订单编号" minWidth="168"></el-table-column>
      <el-table-column prop="name" label="患者" width="158">
        <template slot-scope="{ row: { user_name, user_tel }}">
          <div><span>{{ user_name }}</span>/<span>{{ user_tel }}</span></div>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" minWidth="120" align="center">
        <template slot-scope="{ row: { order_status }}">
          <span>{{ order_status | ordersFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="nurse" label="护工姓名" minWidth="160">
        <template slot-scope="{ row }">
          <div>{{ row | nurseNameTel }}</div>
        </template>
      </el-table-column>
      <el-table-column minWidth="200" label="服务时间">
        <template slot-scope="{ row: { start_at, end_at }}">
          {{ (start_at * 1000) | formatDate('yyyy-MM-dd') }} - {{ (end_at * 1000) | formatDate('yyyy-MM-dd') }}
          <el-tag v-if="(formatDate(end_at * 1000,'yyyy-MM-dd')) === formatDate(new Date(), 'yyyy-MM-dd')" type="danger"
                  size="mini">服务即将结束
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="订单金额" minWidth="120">
        <template slot-scope="scope">
          <span>￥{{ scope.row.total }}</span>
        </template>
      </el-table-column>
      <el-table-column label="退款金额" minWidth="120">
        <template slot-scope="scope">
          <span>￥{{ scope.row.actual_refund_fee }}</span>
        </template>
      </el-table-column>
      <el-table-column minWidth="180" label="下单时间"
      >
        <template slot-scope="scope">
          {{ (scope.row.created_at * 1000) | formatDate('yyyy-MM-dd HH:mm:ss') }}
        </template>
      </el-table-column>+
      <el-table-column   v-if="isAdmin" label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <i v-if="scope.row.is_show === 1" class="el-icon-edit fz24 ml" @click="handleUpdate(scope.row)" title="修改"></i>
          <i v-if="scope.row.is_show === 1" class="el-icon-delete fz24 ml" @click="handleDelete(scope.row.id)" title="删除"></i>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page_size"
        :current-page="page_number"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { fetchHospitalList } from '@/api'
import { OrderStatus } from '@/enum/orders'
import { filterEnum } from '@/utils/filter'
import { OrderAllStatus } from '../../enum/orders'
import { formatDate } from 'element-ui/lib/utils/date-util'
import InsertOrder from './components/InsertOrder'
import { isAdmin } from '../../utils/util'
import { delOrderById } from '../../api'

export default {
  name: 'OrdersManage',
  components: { InsertOrder },
  data() {
    return {
      OrderStatus,
      is_finance: 1,
      is_hospital: 1,
      isAddNurse: false,
      fileList: [],
      search: {
        rangeDate: [
          formatDate(new Date(), 'yyyy-MM-dd 00:00:00'),
          formatDate(new Date(), 'yyyy-MM-dd 23:59:59')
        ],
        hospital_name: '',
        user_name_or_tel: '',
        nurse_name_or_tel: '',
        order_status: ''
      },
      tableLoading: false,
      page_size: 10,
      page_number: 1,
      total: 0,
      pay_total: 0,
      actual_amount: 0,
      refund: 0,
      hospitals: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      tableData: [],
      isAdmin: isAdmin()
    }
  },
  filters: {
    formatDate,
    ordersFilter(val) {
      return filterEnum(val, OrderAllStatus).label || '-'
    },
    nurseNameTel(val) {
      const { nurse_name, nurse_tel } = val
      let str = ''

      if (nurse_name && nurse_name !== '') {
        str += nurse_name
      } else {
        str += '-'
      }
      if (nurse_tel && nurse_tel !== '') {
        str += '/'
        str += nurse_tel
      } else {
        str += '/'
        str += '-'
      }
      return str
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    formatDate,
    init() {
      // order_status 0 超级管理员 1无权限 2有权限 默认1无权限
      const is_finance = sessionStorage.getItem('is_finance')
      const is_hospital = sessionStorage.getItem('is_hospital')
      this.is_finance = is_finance
      this.is_hospital = is_hospital
      const params = this.$store.state.rules.filter(i => i.url === '/orders_')[0]
      this.hospitals = Object.values(params.child)
      this.search.hospital_name = this.hospitals && this.hospitals[0] ? this.hospitals[0].name : ''
      this.getList()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.page_number = 1
      this.getList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.page_size = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page_number = val
      this.getList()
    },
    searchData() {
      this.page_number = 1
      this.getList()
    },
    handleInsertOrder() {
      this.$refs.InsertOrder.handleOpen()
    },
    handleUpdate(info) {
      this.$refs.InsertOrder.handleOpen(info)
    },
    handleDelete(order_id) {
      this.$confirm(`确定删除吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delOrderById({
            order_id
          }).then(res => {
            if (res.status) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
    },
    getList() {
      this.tableLoading = true
      const {
        page_size, page_number, search,
        is_finance,
        is_hospital
      } = this
      const { rangeDate, ...searchInfo } = search
      const params = {
        is_finance,
        is_hospital,
        page_size: page_size,
        page_number: page_number,
        ...searchInfo
      }
      if (rangeDate) {
        params.start_at = rangeDate[0]
        params.end_at = rangeDate[1]
      }
      this.tableLoading = true
      fetchHospitalList(params)
        .then(res => {
          if (res.status) {
            this.tableData = res.data.list
            this.total = res.data.total
            this.pay_total = res.data.amount
            this.actual_amount = res.data.actual_amount
            this.refund = res.data.refund
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    handleDetails(_RowId) {
      this.$router.push('/order-details?id=' + _RowId)
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    width: 100%;

    .imgbox {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .litimg {
        width: 30px;
        height: 30px;
        margin: 3px;
        object-fit: cover;
        cursor: zoom-in;
      }
    }

    .picture {
      width: 100%;
    }

    .block {
      text-align: center;
    }

    .el-pagination {
      margin-top: 20px;
    }

    .total {
      padding: 0 6% 15px;
      color: #26A4B2;
      text-align: right;
      font-weight: bold;
    }
  }
</style>
